/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Language {
  EN = 'en',
  HE = 'he',
}
